import { CategorySlug, TOP_BAR_CATEGORY_GROUPS } from '../config';
import { useExperiments } from '../contexts/ExperimentsContext';
import { useInitialState } from '../contexts/InitialStateContext';
import { useTranslation } from '@wix/wix-i18n-config';
import { useInternalRoutes } from './useInternalRoutes';
import { useSelectedCategory } from './useSelectedCategory';
import { useMemo } from 'react';

interface MenuCategory {
  url: string;
  isActive: boolean;
  label: string;
  slug: string;
}

export interface MenuCategoryGroup {
  title: string;
  categories: MenuCategory[];
}

export const useMenuCategoryGroups = (): MenuCategoryGroup[] => {
  const { is } = useExperiments();
  const { book } = useInitialState();
  const { t } = useTranslation();
  const { category: categoryRoute } = useInternalRoutes();
  const selectedCategory = useSelectedCategory();

  return useMemo(
    () =>
      TOP_BAR_CATEGORY_GROUPS.map(({ categorySlugs, title }) => {
        return {
          title: t(title),
          categories: categorySlugs
            .map((slug) => {
              const category = book?.categories.find((c) => c.slug === slug);

              if (
                slug === CategorySlug.PANTONE &&
                !is('specs.funnel.PantoneWixIntegration', 'true')
              ) {
                return false;
              }

              if (
                slug === CategorySlug.TEST_EMPTY &&
                !is('specs.funnel.testStudioTemplatesEmptyCat', 'true')
              ) {
                return false;
              }

              return category
                ? {
                    url: categoryRoute.build(slug),
                    isActive: slug === selectedCategory?.slug,
                    label: category.displayName,
                    slug,
                  }
                : false;
            })
            .filter(Boolean) as MenuCategory[],
        };
      }),
    [selectedCategory],
  );
};
